import { MutableRefObject, RefCallback } from "react";

export type MutableRef<T> = RefCallback<T> | MutableRefObject<T> | null;

export const setRef =
  <T>(ref: MutableRef<T>) =>
  (current: T) => {
    if (typeof ref === "function") {
      ref(current);
    } else if (ref) {
      ref.current = current;
    }
  };

export const setRefs = <T>(...refs: MutableRef<T>[]) => {
  const setters = refs.map(setRef);
  return (current: T) => {
    for (const setter of setters) {
      setter(current);
    }
  };
};

export type PropsWithoutChildren<P extends object> = Omit<P, "children">;

export function delayEffect(
  millis: number,
  effect: () => () => void,
): () => void {
  const timeout = setTimeout(() => {
    cleanup = effect();
  }, millis);
  let cleanup = () => clearTimeout(timeout);
  return () => cleanup();
}
